module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-footer', {
    staticClass: "my-footer"
  }, [_c('a', {
    attrs: {
      "href": "//support.yousound.com",
      "target": "_blank"
    }
  }, [_vm._v("Support")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/terms"
    }
  }, [_vm._v("Terms")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "#"
    }
  }, [_vm._v("Privacy")]), _vm._v(" "), (!_vm.hideDownload) ? _c('router-link', {
    attrs: {
      "to": "#"
    }
  }, [_vm._v("Download App")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("© " + _vm._s(new Date().getFullYear()) + " YouSound, Inc.")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f42927a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = 1766
// module chunks = 180